import * as React from "react";

import { createHocDisplayName, GetProps } from "../../../Controls/TypingUtils";

import { IControlRegistry } from "./IControlRegistry";
import { useComponentHandleRegistry } from "./ComponentHandleRegistryContext";

interface ComponentHandleRegistryInjectableProps {
    controlRegistry: IControlRegistry;
}

export function withComponentHandleRegistry<
    C extends React.ComponentType<GetProps<C> & ComponentHandleRegistryInjectableProps>,
>(WrappedComponent: C): React.ComponentType<Omit<JSX.LibraryManagedAttributes<C, GetProps<C>>, "controlRegistry">> {
    function WithComponentHandleRegistryWrapper(
        props: Omit<JSX.LibraryManagedAttributes<C, GetProps<C>>, "controlRegistry">
    ): JSX.Element {
        const controlRegistry = useComponentHandleRegistry();
        // @ts-ignore Баг с HOC-ами https://github.com/Microsoft/TypeScript/issues/28938
        return <WrappedComponent {...props} controlRegistry={controlRegistry} />;
    }

    WithComponentHandleRegistryWrapper.displayName = createHocDisplayName(WrappedComponent, "ComponentHandleRegistry");
    return WithComponentHandleRegistryWrapper;
}
